// extracted by mini-css-extract-plugin
module.exports = {"ShareContainer":"ShareContainer_ShareContainer__2Ax-h","ShareLabel":"ShareContainer_ShareLabel__1FcqI","Extend":"ShareContainer_Extend__V3hq0","fade":"ShareContainer_fade__1x9L1"};